<template>
  <div class="toast">
    {{ title }}
  </div>
</template>
<script lang="ts">
  export default {
    name: 'Toast',
    props: {
      title: {
        type: String,
        default: '我是toast'
      }
    },
    setup () {
      return {};
    }
  };
</script>
<style lang="scss" scoped>
  .toast-wrap{
    z-index: 99999;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .toast {
    position: fixed;
    left:50%;
    top:50%;
    transform:translate3d(-50%,-50%,0);
    z-index: 99999;
    max-width: 400px;
    color: #ffffff;
    font-size: 24px;
    line-height: 38px;
    text-align: center;
    border-radius: 10px;
    padding: 20px 30px;
    font-family: PingFang SC-Semibold, PingFang SC;
    background: rgba(0, 0, 0, 0.7);
  }
</style>